var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_568",
    "data-name": "Group 568",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12717",
    "data-name": "Path 12717",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15",
    fill: "#7c97c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12718",
    "data-name": "Path 12718",
    d: "M22.673,6.654,21.638,7.688a.451.451,0,0,1-.319.133l-1.8.007-6.34,6.34a.514.514,0,0,1-.727-.726l6.34-6.34L18.8,5.3a.451.451,0,0,1,.133-.32l1.034-1.034a.456.456,0,0,1,.779.325l0,1.151a.457.457,0,0,0,.457.458l1.152,0a.455.455,0,0,1,.324.778",
    transform: "translate(2.46 0.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12719",
    "data-name": "Path 12719",
    d: "M24.626,18.384a11.1,11.1,0,0,0-.751-9.846,1.267,1.267,0,0,1-.743.242l-.931,0a9.554,9.554,0,1,1-2.42-2.42l0-.93a1.265,1.265,0,0,1,.242-.745,11.182,11.182,0,0,0-1.51-.749,11.087,11.087,0,1,0,6.109,14.444",
    transform: "translate(0.652 0.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12720",
    "data-name": "Path 12720",
    d: "M19.786,15.983a6.671,6.671,0,0,0,0-5.011,6.707,6.707,0,0,0-.613-1.166l-.746.746a5.535,5.535,0,0,1,.408.808,5.652,5.652,0,1,1-2.3-2.7l.746-.746A6.683,6.683,0,0,0,11.1,7.3a6.663,6.663,0,1,0,8.681,8.681",
    transform: "translate(1.389 1.363)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12721",
    "data-name": "Path 12721",
    d: "M15.348,12.241,14.285,13.3a1.451,1.451,0,0,1-.334.516A1.466,1.466,0,1,1,12.4,11.412l1.062-1.061a2.494,2.494,0,1,0,1.889,1.89",
    transform: "translate(2.084 2.058)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon-target.5466c62305dacdbb3f728a4dc2f3f888.svg";
export { ForwardRef as ReactComponent };